export default __webpack_public_path__ + "static/media/Display-mart.84c0f8e6.webp";